export const localZone=()=>Intl.DateTimeFormat().resolvedOptions().timeZone||'UTC';
export function timeChoices(value,timeZone){
 if(!/^\d{4}-\d\d-\d\dT\d\d:\d\d$/.test(value||''))return [];
 const [y,m,d,h,min]=value.split(/[-T:]/).map(Number),naive=Date.UTC(y,m-1,d,h,min);
 if(!Number.isFinite(naive))return [];
 const fmt=new Intl.DateTimeFormat('en-CA',{timeZone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'});
 const matches=[];
 for(let shift=-14*60;shift<=14*60;shift+=15){const at=naive+shift*60000,p=Object.fromEntries(fmt.formatToParts(at).map(p=>[p.type,p.value]));if(`${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`===value)matches.push(new Date(at).toISOString());}
 return [...new Set(matches)].sort();
}
export function displayTime(iso,timeZone){return new Intl.DateTimeFormat(undefined,{timeZone,dateStyle:'medium',timeStyle:'long'}).format(new Date(iso));}
